const ModelsKnowledge = () => {
	return <></>;
};

export default ModelsKnowledge;
